export const LIBRARY_TYPE_OPTIONS = [
  { value: 'rich_text', label: 'Texto enriquecido' },
  { value: 'video', label: 'Video' },
  { value: 'pdf', label: 'Documento PDF' },
  { value: 'pdf_folder', label: 'Carpeta de PDF' },
  { value: 'image', label: 'Imagen' },
  { value: 'audio', label: 'Audio' },
  { value: 'download', label: 'Archivo descargable' },
  { value: 'html', label: 'HTML' },
  { value: 'external_link', label: 'Enlace externo' },
  { value: 'scorm', label: 'SCORM' },
  { value: 'xapi', label: 'xAPI' },
  { value: 'cmi5', label: 'cmi5' },
] as const;

export const MEDIA_FILTER_BY_TYPE: Record<string, string> = {
  video: 'video',
  pdf: 'pdf',
  audio: 'audio',
  image: 'image',
};

export const TYPES_REQUIRING_MEDIA = new Set(['video', 'pdf', 'audio', 'image', 'download']);
export const TYPES_REQUIRING_CONTENT = new Set(['rich_text', 'html']);
export const INTEGRATION_TYPES = new Set(['h5p', 'assessment', 'scorm', 'xapi', 'cmi5']);

export function slugifyLibrary(value: string) {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function mediaLabelForType(type: string) {
  return TYPES_REQUIRING_MEDIA.has(type)
    ? 'Archivo multimedia (obligatorio si no usa enlace externo)'
    : 'Multimedia File (opcional)';
}
